<template>
  <div class="info-cards-container">
    <div v-for="card in cardsItems" :key="card.key" class="info-card">
      <info-card :title="card.title" :description="card.value" :tooltip="card.tooltip" :card-key="card.key">
        <template v-if="card.key === 'target'" slot="additional-content"> </template>
      </info-card>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import InfoCard from '@/components/campaigns/InfoCard.vue'

export default {
  name: 'CampaignInfoCards',
  components: {
    InfoCard,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    cardsItems() {
      return [
        {
          key: 'validity-period',
          title: 'Período de validade',
          value: `${DateTime.fromFormat(this.campaign.start_date.toString(), 'yyyy-MM-dd').toFormat('dd/MM/yyyy')} - ${DateTime.fromFormat(
            this.campaign.end_date.toString(),
            'yyyy-MM-dd'
          ).toFormat('dd/MM/yyyy')}`,
          tooltip: '',
          hasSlot: false,
        },
        {
          key: 'campaign-template',
          title: 'Modelo de destaque',
          value: this.campaign.activatable ? 'Expandido' : 'Padrão',
          tooltip: '',
          hasSlot: false,
        },
        {
          key: 'units',
          title: 'Lojas participantes',
          value: `${this.campaign.units.length} loja${this.campaign.units.length !== 1 ? 's' : ''}`,
          hasSlot: false,
        },
        {
          key: 'products',
          title: 'Produtos',
          value: `${this.products.length} produto${this.products.length !== 1 ? 's' : ''}`,
          tooltip: '',
          hasSlot: false,
        },
      ]
    },
  },
}
</script>

<style scoped lang="scss">
.info-cards-container {
  width: 100%;
  padding: 0 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  align-items: center;
  .info-card {
    min-width: 400px;
    min-height: 100px;
  }
}
.segments-text {
  span {
    color: $cinza-d10;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0em;
  }
}
</style>
